module.exports = __webpack_public_path__ + "static/media/hashtag-nft-8.e5198f66.jpg";